import format from 'date-fns/format';
import startOfMonth from 'date-fns/startOfMonth';
import subMonths from 'date-fns/subMonths';

export const galateaWrapUpUtils = {
  getWrapUpKeyForDate: (date: Date) => {
    // On the 1st of the month, we still want to show the wrap of the previous to previous month. Eg: on April 1, we still want to show the wrap of February.
    if (date.getDate() === 1) {
      return format(subMonths(date, 2), 'yyyy-MM-01');
    }

    // We always show the wrap of the previous month. Eg: on April 2, we show the wrap of March.
    return format(subMonths(startOfMonth(date), 1), 'yyyy-MM-01'); // we hardcode `-01` because we want to get the first day of the month
  },
};
